import { render } from "./ingredientPreference.vue?vue&type=template&id=4623545a&scoped=true&ts=true"
import script from "./ingredientPreference.vue?vue&type=script&lang=ts"
export * from "./ingredientPreference.vue?vue&type=script&lang=ts"

import "./ingredientPreference.vue?vue&type=style&index=0&id=4623545a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4623545a"]])

export default __exports__